import React, { Component } from 'react';
import './App.css';
import ApolloClient from "apollo-boost";
import { ApolloProvider, Query } from "react-apollo"
import ListOfJobs from "./ListOfJobs"
import PostAJob from "./components/PostAJob"
import Dashboard from "./Dashboard"
import { POSTS_COUNT } from './components/queries';
import LogRocket from './LogRocket';
import { constRef } from "./constants";

const ACCESS_TOKEN = '@rock517';
const client = new ApolloClient({
  uri: "https://react-hasura-graph.herokuapp.com/v1/graphql",
  headers: {
    'x-hasura-admin-secret': `${ACCESS_TOKEN}`,
  }
});


class App extends Component {

  constructor() {
    super();
    this.getData = this.getData.bind(this);
  }

  state = {
    options: constRef.optionsRef,
    skills: [],
    count: ''
  };


  onSelect = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }

  onRemove = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }

  getData(val) {
    // do not forget to bind getData in constructor
    this.setState({ count: val })
  }

  render() {


    return (
      (
        <ApolloProvider client={client}>
          <Query query={POSTS_COUNT}>
            {({ loading, error, data }) => {
              if (loading) return (<LogRocket />);
              if (error) return (console.log(error));

              return (

                <div className="card">
                  <div className="card-header ">
                    <h2 >  Pay U Work
                    <div id="social" className="float-right">
                        <a className="fa fa-youtube icon" href="https://youtube.com/" target="_blank"></a>
                        <a className="fa fa-linkedin icon" href="https://in.linkedin.com/in/brahmaiah-rayalla-51541452" target="_blank"></a>
                        <a className="fa fa-github icon" href="https://github.com/Brahmaiah-Rayalla" target="_blank"></a>
                        <a className="fa fa-whatsapp icon" href="https://api.whatsapp.com/send?phone=919542483715" target="_blank"></a>
                      </div>
                    </h2>
                  </div>
                  <br />
                  <ul className="nav nav-tabs" role="tablist">
                    <li role="presentation" ><a href="#dashboard" aria-controls="dashboard" role="tab" data-toggle="tab"><h4><i className="fa fa-dashboard fa"> </i> Dashboard</h4></a></li>
                    <li role="presentation"><a href="#postjob" aria-controls="postjob" role="tab" data-toggle="tab"><h4><i className="fa fa-briefcase"> </i> Post Job</h4></a></li>
                    <li role="presentation" className="active"><a href="#listjobs" aria-controls="listjobs" role="tab" data-toggle="tab"><h4><i className="fa fa-list-ul"></i> Jobs <span className="badge badge-light float-right">{data.posts.posts_agg.count}</span> </h4></a></li>
                    {/*<li role="presentation"><a href="#settings" aria-controls="settings" role="tab" data-toggle="tab"><h4><i className="fa fa-cog"></i> About Us</h4></a></li>*/}
                  </ul>


                  <div className="tab-content">
                    <div role="tabpanel" className="tab-pane" id="dashboard">
                      {/*<div className="panel panel-default">*/}
                      <div className="panel-body"><Dashboard /></div>

                    </div>
                    <div role="tabpanel" className="tab-pane" id="postjob">
                      {/* <div className="panel panel-default">
                              <div className="panel-heading"><h2><i className="fa fa-plus-circle" aria-hidden="true"></i> Post Job</h2></div>*/}
                      <div><PostAJob /></div>

                    </div>
                    <div role="tabpanel" className="tab-pane active" id="listjobs">
                      {/*<div className="panel panel-default">
                              <div className="panel-heading"><h2><i className="fa fa-list-ul" aria-hidden="true"></i> Freelancing Jobs
                            <span className="badge badge-light float-right">{data.posts.posts_agg.count}</span>
                              </h2></div>*/}

                      <div><ListOfJobs skills={this.state.skills} /></div>


                    </div>
                    <div role="tabpanel" className="tab-pane" id="settings">
                      <h4>Im a fullstack developer with good amount of exeperience on Latest Technologies.</h4>
                      <h5><ul>
                        <li><a href="https://github.com/Brahmaiah-Rayalla/"><i className="fa fa-github fa-2x" aria-hidden="true"></i> GitHub</a></li>
                        <li><a href="http://brahma517.blogspot.com"><i className="fa fa-rss-square fa-2x" aria-hidden="true"></i> Blog </a></li>
                        <li>Java</li>
                        <li>J2ee</li>
                        <li>Spring IOC, MVC, JDBC, AOP, Thymeleaf, Boot</li>
                        <li>Hibernate, Postgresql</li>
                        <li>React</li>
                        <li>Hasura GraphQL</li>
                      </ul>
                      </h5>

                    </div>
                  </div>
                </div>




              );
            }
            }
          </Query>
        </ApolloProvider >
      )
    );
  }
}

export default App;
